import type { PaymentType } from '#src/app/shared/utils/payments';

import { usePromoteFormState } from '../../../formContext/formState';
import { useTracking } from '../useTracking';

import { useValidationResult } from './useValidationResult';

export function useValidate(): (paymentType: PaymentType) => Promise<boolean> {
	const [, { clearLoading, setValidationErrors }] = usePromoteFormState();
	const { trackSubmitInvalid, trackError } = useTracking();
	const validationResult = useValidationResult();

	return async function validate(paymentType: PaymentType): Promise<boolean> {
		setValidationErrors(null);

		const { valid, errors: newValidationErrors } = validationResult(paymentType);
		if (!valid) {
			trackError({
				errorMessage: `Invalid ${Object.keys(newValidationErrors).join(', ')}`,
				errorType: Object.keys(newValidationErrors),
				paymentType,
			});
			setValidationErrors(newValidationErrors);
			trackSubmitInvalid({
				paymentType,
				errorMessage: JSON.stringify(newValidationErrors),
			});
			clearLoading();
			return Promise.resolve(false);
		}
		return Promise.resolve(true);
	};
}
